<template>
    <div>
        <SectionHeader
            :label="$t('mypage.favoriteModule.header')"
            style="position:relative"
            class="mb-4"
        >
            <BaseButton
                slot="right"
                variant="outline-secondary"
                style="position:absolute;top:7px;right:6px;height:30px;width:68px;"
                tiny
                @click="toFavorites"
            >
                {{ $t('mypage.favoriteModule.seeAll') }}
            </BaseButton>
        </SectionHeader>
        <FavoriteGridSkeleton v-if="loading()" :count="3" />
        <FavoriteGrid v-else-if="data().length > 0" :data="data()" />
        <div
            v-else
            class="d-flex flex-column align-items-center justify-content-center"
        >
            <NoContent :caption="$t('mypage.favoriteModule.noFavorites')">
            </NoContent>
        </div>
    </div>
</template>

<script>
// Components
import SectionHeader from '~/components/layouts/SectionHeader';
import NoContent from '~/components/miscellaneous/NoContent';
import FavoriteGrid from '~/shared/favoritemodule/FavoriteGrid';

// Skeletons
import FavoriteGridSkeleton from '~/shared/favoritemodule/skeletons/FavoriteGridSkeleton';

// Utils
import { favoriteTemplate } from '~/store/modules/candidateModule';

// Assets
import EmptySvg from '~/assets/img/empty.svg';

export default {
    name: 'FavoriteModule',
    components: {
        FavoriteGridSkeleton,
        SectionHeader,
        FavoriteGrid,
        NoContent,
    },
    data: () => ({
        emptySvg: EmptySvg,
        forceUpdate: true,
    }),
    computed: {
        favorites() {
            const data = this.$interfaces.candidate.favorite.get({
                reactive: true,
                limit: 15,
                forceUpdate: this.forceUpdate,
                onlyActive: true,
            });
            this.forceUpdate = false;
            return data;
        },
    },
    methods: {
        toFavorites() {
            this.$router.push(this.$URLS.favorites);
        },
        goToFavorite(fav) {
            let jobId = null;
            if (fav.job) {
                jobId = fav.job.id;
            } else {
                jobId = ''.concat(fav.jobAdId, '?isJobAdId=true');
            }
            this.$router.push(this.$URLS.jobDetail.concat('/', jobId));
        },
        data() {
            return (this.favorites.data.results
                ? this.favorites.data.results.map(favoriteTemplate)
                : []
            ).slice(0, 3);
        },
        loading() {
            return this.favorites.loading;
        },
    },
};
</script>

<style scoped>
.empty-image {
    min-height: 186px;
    max-width: 186px;
    max-height: 186px;

    object-fit: scale-down;
    margin: auto;
}
</style>
